/* eslint-disable no-undef */

import * as Sentry from '@sentry/vue';
import _ from '#/lodash-extended';
import Analytics from 'c/WtAnalytics';
import { workPool } from '@wochitnpm/helpers';

export default class ExternalScripts {
  static MAIN_FONT = '';
  static loadAll({ isImpededTemplatizer }) {
    setTimeout(() => {
      ExternalScripts.loadFonts({ isImpededTemplatizer });
      ExternalScripts.loadAnalytics();
      ExternalScripts.loadIntegrations();
      ExternalScripts.loadMonitors();
    }, 0);
  }

  static loadFonts({ isImpededTemplatizer }) {
    // load webfonts async
    const families = [];
    if (isImpededTemplatizer) {
      families.push('Montserrat:400,500,300,100');
      ExternalScripts.MAIN_FONT = 'Montserrat';
    } else {
      families.push('Roboto:400,500,300,100');
      ExternalScripts.MAIN_FONT = 'Roboto';
    }

    WebFont.load({
      google: {
        families,
      },
      custom: {
        urls: [
          'prod' === serverProfile.environment
            ? `https://cdn.icomoon.io/71781/WochitIcons/style.css?v=${
                serverProfile.version +
                (serverProfile.useCacheBuster ? serverProfile.timestamp : '')
              }`
            : 'https://i.icomoon.io/public/18527259b7/WochitIcons/style.css?v1=' +
              serverProfile.version,
        ],
      },
    });
  }

  static loadAnalytics() {
    // init serviceWorker
    // NOTE: mutes XHR::upload.onprogress event
    // if (navigator.serviceWorker){
    //   if (navigator.serviceWorker.controller) {
    //     console.log('[PWA] active service worker found, no need to re-register');
    //   } else {
    //     //Register the ServiceWorker
    //     navigator.serviceWorker.register('/sw.js', {
    //       scope: './'
    //     }).then(function(reg) {
    //       console.log('Service worker has been registered for scope:'+ reg.scope);
    //     });
    //   }
    // }

    // Google Analytics
    (function (i, s, o, g, r, a, m) {
      i.GoogleAnalyticsObject = r;
      (i[r] =
        i[r] ||
        function () {
          // eslint-disable-next-line prefer-rest-params
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      'script',
      '//www.google-analytics.com/analytics.js',
      'ga'
    );
    ga('create', 'UA-47806471-1', 'auto');
    ga('send', 'pageview');

    // walkme
    // eslint-disable-next-line no-constant-condition
    if (serverProfile.environment !== 'dev') {
      (function () {
        const walkme = document.createElement('script');
        walkme.type = 'text/javascript';
        walkme.async = true;
        if ('prod' === serverProfile.environment) {
          walkme.src =
            'https://cdn.walkme.com/users/3209d8a0c7c64874845a30949e900c25/walkme_3209d8a0c7c64874845a30949e900c25_https.js';
        } else {
          walkme.src =
            'https://cdn.walkme.com/users/3209d8a0c7c64874845a30949e900c25/test/walkme_3209d8a0c7c64874845a30949e900c25_https.js';
        }
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(walkme, s);
        window._walkmeConfig = { smartLoad: true };
      })();
    }

    // segment.io
    !(function () {
      const analytics = (window.analytics = window.analytics || []);
      if (!analytics.initialize) {
        if (analytics.invoked) {
          window.console &&
            console.error &&
            console.error('Segment snippet included twice.');
        } else {
          analytics.invoked = !0;
          analytics.methods = [
            'trackSubmit',
            'trackClick',
            'trackLink',
            'trackForm',
            'pageview',
            'identify',
            'group',
            'track',
            'ready',
            'alias',
            'page',
            'once',
            'off',
            'on',
          ];
          analytics.factory = function (t) {
            return function () {
              // eslint-disable-next-line prefer-rest-params
              const e = Array.prototype.slice.call(arguments);
              e.unshift(t);
              analytics.push(e);
              return analytics;
            };
          };
          for (let t = 0; t < analytics.methods.length; t++) {
            const e = analytics.methods[t];
            analytics[e] = analytics.factory(e);
          }
          analytics.load = function (t) {
            const e = document.createElement('script');
            e.type = 'text/javascript';
            e.async = !0;
            e.src =
              ('https:' === document.location.protocol
                ? 'https://'
                : 'http://') +
              'cdn.segment.com/analytics.js/v1/' +
              t +
              '/analytics.min.js';
            const n = document.getElementsByTagName('script')[0];
            n.parentNode.insertBefore(e, n);
          };
          analytics.SNIPPET_VERSION = '3.0.1';

          if ('prod' === serverProfile.environment) {
            analytics.load('48V6kFVMtjM3tGjrHDDlL6AajVZSelot');
          } else {
            analytics.load('jK1mROmsl2Rl3Y7QIFUJQCsJMZ8mlO0k');
          }
        }
      }

      (function identify() {
        const userTraits = _.pickBy({
          channelId: tk.context.user.channelId,
          studio_name: tk.context.relatedProgrammerList[0].programmerName,
          email: tk.context.user.username,
          user_type: tk.context.user.employeeType,
          first_name: tk.context.user.firstName,
          last_name: tk.context.user.lastName,
          account_name: tk.context.user.accountName,
          account_manager_name: tk.context.user.accountManagerName,
          account_sales_rep: tk.context.user.accountSalesRep,
        });

        const UTM = tk.context.user.UTM;

        if (UTM) {
          const UTMObj = _.pickBy({
            'UTM Content': UTM.UTMContent,
            'UTM Term': UTM.UTMTerm,
            'UTM Name': UTM.UTMCampaign,
            'UTM Medium': UTM.UTMedium,
            'UTM Source': UTM.UTMSource,
          });

          Object.assign(userTraits, UTMObj);
        }

        if (_.isDefined(app.experiment) && app.experiment.inProgress()) {
          Object.assign(
            userTraits,
            app.experiment.analyticsIdentifyBreadcrumbs
          );
        }

        if (sessionStorage.getItem('authentication-manager')) {
          Object.assign(userTraits, {
            authentication_manager: sessionStorage.getItem(
              'authentication-manager'
            ),
          });
        }

        Analytics.trigger(
          'analytics:identify',
          app.rootStore.getters['user/id'],
          userTraits
        );
      })();
    })();
  }

  static loadIntegrations() {
    // Load the Google API Loader script (google drive picker)
    (function () {
      const googleScript = document.createElement('script');
      googleScript.type = 'text/javascript';
      googleScript.src =
        'https://apis.google.com/js/api.js?onload=onGoogleApiLoad';
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(googleScript, s);
    })();

    window.onGoogleApiLoad = function () {
      window.gapi.load('auth');
      window.gapi.load('picker');
      window.gapi.load('client', function () {
        gapi.client.load('drive', 'v2');
      });
    };

    // Microsoft Onedrive
    (function () {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://js.live.net/v7.2/OneDrive.js';
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(script, s);
    })();

    // dropbox chooser
    (function () {
      const dropbox = document.createElement('script');
      dropbox.type = 'text/javascript';
      dropbox.async = true;
      dropbox.src = 'https://www.dropbox.com/static/api/2/dropins.js';
      dropbox.id = 'dropboxjs';
      if ('prod' === serverProfile.environment) {
        dropbox.setAttribute('data-app-key', 'hpzdjfdrurspcjf');
      } else {
        dropbox.setAttribute('data-app-key', 'uxwq7dxzn3hpk8o');
      }
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(dropbox, s);
    })();
  }

  static loadMonitors() {
    if (/test|prod/.test(serverProfile.environment)) {
      Sentry.init({
        dsn: 'https://5093ca02363240748ea9eca5b6526036@o119461.ingest.sentry.io/263395',
        release: serverProfile.version,
        environment: serverProfile.environment,
        Vue: app.Vue,
        attachProps: true,
        logErrors: true,
      });

      Sentry.configureScope((scope) => {
        // Sentry.configureScope should be called after Sentry.init, otherwise this callback won't be invoked
        scope.setUser(
          Object.assign(Analytics.userTraits, {
            id: tk.context.user.employeeId,
          })
        );
        workPool.once(
          {
            type: workPool.job.waitTillDefined.type,
            context: (jc) =>
              jc.baseObj === window && jc.field === 'FS.getCurrentSessionURL',
          },
          () => {
            // https://help.fullstory.com/hc/en-us/articles/360020623274-FS-event-API-Sending-custom-event-data-into-FullStory?source=search#Instructions
            const url = window.FS.getCurrentSessionURL(true);
            if (!_.isEmpty(url)) {
              scope.setExtra('fullStory', url);
            }
          }
        );
        workPool.job.waitTillDefined.start({
          baseObj: window,
          field: 'FS.getCurrentSessionURL',
          timeout: app.TIME.minute(2) + _.random(-10e3, +10e3),
        });
      });
    }
  }
}
